import { AbstractControl, ValidatorFn } from '@angular/forms';

export function mimetypeValidator(types: string | string[] | readonly string[]): ValidatorFn {
  const mimetypes = Array.isArray(types) ? types : [types];

  return (control: AbstractControl<{ file: File; fileUrl: string }>) => {
    const file = control.value.file;

    if (file && !mimetypes.includes(file.type)) {
      return {
        mimetype: true
      };
    }

    return null;
  };
}

export function maxSizeValidator(maxSize: number): ValidatorFn {
  return (control: AbstractControl<{ file: File; fileUrl: string }>) => {
    const file = control.value.file;

    if (file && file.size > maxSize) {
      return {
        maxSize: true
      };
    }

    return null;
  };
}
